<template>
  <div>
    <!-- 搜索表单 -->
    <el-form :model="params" label-width="77px" class="ele-form-search" @keyup.enter.native="searchChart" @submit.native.prevent>
      <el-row :gutter="15">
        <el-col :md="6" :sm="12">
          <el-form-item label="日期:">
            <el-date-picker
              v-model="date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="handleDateChange"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :md="3" :sm="12">
          <el-form-item label="学部:">
            <el-select v-model="params.branchId" placeholder="请选择学部" style="width: 140px" @change="handleChange($event, 2)" clearable>
              <el-option v-for="item in branchList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="3" :sm="12">
          <el-form-item label="年级:">
            <el-select v-model="params.gradeId" placeholder="请选择年级" style="width: 140px" @change="handleChange($event, 3)" clearable>
              <el-option v-for="item in gradeList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="4" :sm="12">
          <el-form-item label="级部:">
            <el-select v-model="params.id" placeholder="请选择级部" style="width: 140px" @change="handleChange($event, 4)" clearable>
              <el-option v-for="item in subGradeList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="4" :sm="12">
          <div class="ele-form-actions">
            <el-button type="primary" @click="searchChart" icon="el-icon-search" class="ele-btn-icon">查询</el-button>
            <el-button type="primary" @click="exportData" icon="el-icon-download" class="ele-btn-icon">导出</el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div class="analysis-chart-card-content">
      <ele-chart ref='charts' :option="option" style="height: 500px" />
    </div>
  </div>
</template>

<script>
  import EleChart from '@/components/EleChart';
  import { accessStatisticsChart, accessStatisticsChartExport, selectionList } from '@/config/fengyi/examine';
  export default {
    name: 'SimpleGradeItem',
    components: { EleChart },
    data() {
      return {
        params: {
          startDay: '',
          endDay: '',
          id: undefined,
          type: 1,
          branchId: undefined,
          gradeId: undefined,
        },
        date: null,
        branchList: [],
        gradeList: [],
        subGradeList: [],
        subGradeName: '',
        chartData: undefined,
      };
    },
    computed: {
      option() {
        return {
          tooltip: {
            trigger: 'item',
          },
          legend: {
            orient: 'horizontal',
            left: 'center',
            bottom: 0,
          },
          series: [
            {
              name: this.subGradeName,
              type: 'pie',
              radius: '40%',
              center: ['50%', '40%'],
              data: this.chartData,
              label: {
                show: true,
                formatter: '{b}: {c} ({d}%)',
              },
            },
          ],
        };
      },
    },
    created() {
      this.searchListbyType(1);
    },
    methods: {
      // 搜索下拉选
      searchListbyType(type, id) {
        let data = {
          type: type,
          id: id,
        };
        selectionList(data).then((res) => {
          if (res.data.resCode == 200) {
            if (type == 1) {
              //校部
              this.branchList = res.data.data;
            } else if (type == 2) {
              //年级
              this.gradeList = res.data.data;
            } else if (type == 3) {
              //级部
              this.subGradeList = res.data.data;
            }
          }
        });
      },
      // 搜索下拉框值变化
      handleChange(value, type) {
        if (type == 2) {
          this.gradeList = [];
          this.subGradeList = [];
          this.params.gradeId = undefined;
          this.params.id = undefined;
        } else if (type == 3) {
          this.subGradeList = [];
          this.params.id = undefined;
        } else if (type == 4) {
          this.subGradeName = this.subGradeList.find((item) => item.id == value).name;
        }
        this.searchListbyType(type, value);
      },
      handleDateChange(value) {
        this.params.startDay = value[0];
        this.params.endDay = value[1];
      },
      // 查询数据
      searchChart() {
        if (!this.params.id) return this.$message.error('请选择到级部');
        accessStatisticsChart(this.params).then((res) => {
          if (res.data.resCode == 200) {
            this.chartData = res.data.data;
            this.$refs.charts.init()
            this.$refs.charts.resize()
          }
        });
      },
      // 导出数据
      exportData() {
        accessStatisticsChartExport(this.params).then((res) => {
          let blob = new Blob([res.data], {
            type: 'application/octet-stream',
          });
          let objectUrl = URL.createObjectURL(blob);
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = objectUrl;
          let filename = window.decodeURI(res.headers['content-disposition'].split('=')[1], 'UTF-8');
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); // 下载完成移除元素
          window.URL.revokeObjectURL(objectUrl); // 释放掉blob对象
        });
      },
    },
  };
</script>

<style scoped></style>
